import React, { Fragment } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import StyleEditor from './StyleEditor.js';
import PropsEditor from './componentProps/PropsEditor.js';
import DataSourceEditor from './DataSourceEditor.js';
import './properties.css.js';

const PropertiesEditor = (props) => {
    const handleChange = (e) => {
        props.propsUpdated(e);
    };
    const propertyEditor = (type) => {
        if (type === "flow") {
            return React.createElement(TabView, { panelContainerClassName: "p-0" },
                React.createElement(TabPanel, { contentClassName: "p-3 overflow-x", headerClassName: "flex-1 align-content-center justify-content-between align-self-stretch text-center", header: "Properties" },
                    React.createElement(PropsEditor, { propsUpdated: (e) => handleChange(e), params: props.params, selectedProps: props.selectedProps })));
        }
        else {
            return React.createElement(TabView, { panelContainerClassName: "p-0" },
                React.createElement(TabPanel, { contentClassName: "p-3 overflow-x", headerClassName: "flex-1 align-content-center justify-content-between align-self-stretch text-center", header: "Properties" },
                    React.createElement(PropsEditor, { propsUpdated: (e) => handleChange(e), params: props.params, selectedProps: props.selectedProps })),
                React.createElement(TabPanel, { contentClassName: "p-3 overflow-auto", headerClassName: "flex-1 align-content-center justify-content-between align-self-stretch text-center", header: "Style" },
                    React.createElement(StyleEditor, null)),
                React.createElement(TabPanel, { contentClassName: "p-3 overflow-auto", headerClassName: "flex-1 align-content-center justify-content-between align-self-stretch text-center", header: "Data Model" },
                    React.createElement(DataSourceEditor, null)));
        }
    };
    return React.createElement(Fragment, null, propertyEditor(props.type));
};

export { PropertiesEditor as default };
//# sourceMappingURL=Properties.js.map
